import * as React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { IntelligentCloseUpShotComponent, photoCaptureFileUploadFailedAction, photoCaptureIntelligentViewChangeAction, photoCaptureIntelligentPhotoUploadSuccessAction } from "../../../domain/photoCapture";
import { getQuestionnaireEvaluationQuestion } from "../../../domain/questionnaireEvaluation";
import { getGPCTheme } from '../selectors';
const mapStateToProps = (state, ownProps) => {
    return {
        appTheme: getGPCTheme(state),
        questionText: getQuestionnaireEvaluationQuestion(state)
    };
};
const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({
        photoCaptureFileUploadFailedAction,
        onViewChange: photoCaptureIntelligentViewChangeAction,
        onSelectedFileUpload: photoCaptureIntelligentPhotoUploadSuccessAction
    }, dispatch);
};
const IntelligentCloseUpShotComponentWrapper = (props) => React.createElement(IntelligentCloseUpShotComponent, Object.assign({}, props));
export const ConnectedIntelligentCloseUpComponent = connect(mapStateToProps, mapDispatchToProps)(IntelligentCloseUpShotComponentWrapper);
//# sourceMappingURL=ConnectedIntelligentCloseUpComponent.js.map